module.exports = __webpack_public_path__ + "media/images/responsive/flow/flow4-waso-d42129c3d6d0b3578213c1e2e3f0e01a.jpg";